














import Vue from "vue";
import Component from "vue-class-component";
import { State, Action, namespace } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { Auth } from "@/http/api/auth";

const Modal = namespace("modal");
const HotelModule = namespace("HotelModule");

@Component({
  name: "ErrorModal",
})
export default class ErrorModal extends Vue {
  @Prop({ default: "temporary" }) reason!: "session" | "permission" | "temporary";
  @Prop({ default: "" }) referenceId!: string;

  @Modal.Action("handleCancel") handleCancel: any;
  @Modal.Action("handleOk") handleOk: any;
  @HotelModule.Action("toHotelUrl") toHotelUrl: any;

  loggingOut = false;

  get title() {
    switch (this.reason) {
      case "session":
        return "로그인이 만료되었습니다.";

      case "permission":
        return "이 호텔에 접속할 수 없습니다.";

      default:
        return "호텔 정보를 불러오지 못했습니다.";
    }
  }

  get description() {
    switch (this.reason) {
      case "session":
        return "로그인 화면으로 이동하여 다시 로그인해 주세요.";

      case "permission":
        return "호텔 소속 또는 접속 권한을 확인해 주세요.";

      default:
        return "잠시 후 다시 시도해 주세요. 문제가 계속되면 로그인 화면으로 이동해 주세요.";
    }
  }

  retry() {
    window.location.reload();
  }

  toSelectHotel() {
    this.toHotelUrl({ path: "selectHotel" });
  }

  async logout() {
    if (this.loggingOut) {
      return;
    }

    this.loggingOut = true;
    localStorage.removeItem("token");

    try {
      await Promise.race([Auth.logout(), this.wait(1500)]);
    } catch {}

    window.location.replace(this.loginUrl);
  }

  get loginUrl() {
    const protocol = process.env.VUE_APP_PROTOCOL || window.location.protocol.replace(":", "");
    const configuredDomain = process.env.VUE_APP_DOMAIN;
    const currentHostname = window.location.hostname;
    const hasSubdomain = currentHostname.split(".").length >
      (currentHostname.includes(".co.kr") ? 3 : 2);
    const fallbackDomain = hasSubdomain
      ? currentHostname.substring(currentHostname.indexOf(".") + 1)
      : currentHostname;
    const domain = configuredDomain || fallbackDomain;
    const configuredPort = process.env.VUE_APP_PORT;
    const portSuffix = configuredPort && configuredPort !== "80" && configuredPort !== "443"
      ? `:${configuredPort}`
      : "";

    return `${protocol}://${domain}${portSuffix}/`;
  }

  wait(milliseconds: number) {
    return new Promise(resolve => window.setTimeout(resolve, milliseconds));
  }
}
Vue.component("ErrorModal", ErrorModal);
